module.exports = __webpack_public_path__ + "static/media/red.88ce128a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/red.jpeg
// module id = 2046
// module chunks = 0